'use client';

import { useConsentGatedInit } from '../hooks/useConsentGatedInit';
import { getBranchConfig } from './utils';

export const BranchV2 = () => {
    const config = getBranchConfig();

    useConsentGatedInit({
        src: config.branchScriptUrl,
        consentGroup: 'C0004',
        onReady: () => {
            if (!window.branch?.init || !config.branchKey) return;

            window.branch.init(config.branchKey, {
                ...(config.enableJourneys && { enable_journeys: true }),
                ...(config.debug && { debug: true }),
            });
        },
    });

    return null;
};
